import React from 'react'

export default function About(props) {

    return (
        <div className="container">
            <div className="about">
                <a href="https://harshdipsingh.com" ><p className="text-start" >Made By: Harshdip Singh</p></a>
            </div>
        </div>
    )
}
